import React from 'react';

interface IProps {
  className?: string;
}

export function ArrowUp(props: IProps) {
  return (
    <svg
      width={10}
      height={11}
      viewBox="0 0 10 11"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>{'Arrow upp'}</title>
      <g
        stroke="#00A651"
        strokeWidth={1.152}
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M4.968 10.424V.632M.936 4.664L4.968.632 9 4.664" />
      </g>
    </svg>
  );
}
